
import { supabase } from "@/integrations/supabase/client";

export const articleVersionService = {
  async getArticleVersions(articleId: string) {
    try {
      const { data, error } = await supabase
        .from('article_versions')
        .select(`
          id,
          version_number,
          title,
          created_at,
          created_by,
          change_summary
        `)
        .eq('article_id', articleId)
        .order('version_number', { ascending: false });

      if (error) throw error;
      
      return { data, error: null };
    } catch (error) {
      console.error('Error getting article versions:', error);
      return { data: null, error };
    }
  },
  
  async revertToVersion(articleId: string, versionId: string) {
    try {
      // Use the database function to revert to a specific version
      const { data, error } = await supabase
        .rpc('revert_to_version', { 
          article_id: articleId,
          version_id: versionId
        });

      if (error) throw error;
      
      return { data, error: null };
    } catch (error) {
      console.error('Error reverting to version:', error);
      return { data: null, error };
    }
  }
};
